import { memo, useCallback } from 'react';
import { useComponentsContext, useEventContext, useInteractionContext } from '../lib/context';
import { useIsHoveredDay } from '../lib/hooks/data';

export default memo(({ data, utcOffset }: any) => {
  const { DataTable } = useComponentsContext();
  const { handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();
  const { isHovered, isSelected } = useInteractionContext();

  const isHoveredDay = useIsHoveredDay(data, utcOffset);

  const isHighlighted = useCallback(
    (id: any) => isHovered(id) || isSelected(id) || isHoveredDay(id),
    [isHovered, isSelected, isHoveredDay],
  ); // prettier-ignore

  return (
    <DataTable
      data={data}
      isHighlighted={isHighlighted}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
});
